import { ScheduleStopValue } from "pages/shipper/RequestFormV2/defaults/scheduleDefaults";

/** Address country preferred; fall back to port country for airport/seaport-only stops. */
export function getHasMultipleCountries(stops: ScheduleStopValue[] | undefined): boolean {
  if (!stops) return false;
  const countries = new Set(
    stops.map((stop) => stop.country_name || stop.port_country).filter(Boolean),
  );
  return countries.size >= 2;
}
